<template>
  <v-app-bar density="compact">
    <v-container class="mx-auto d-flex align-center justify-center">
      <v-btn
          class="mr-1"
          color="black"
      >
        <template v-slot:prepend>
          <v-icon :icon="['fas', 'bars']" />
        </template>
        ФАЙЛ
        <v-menu activator="parent">
          <v-list>
            <v-list-item v-on:click="null">
              <template v-slot:title>
                Отчёт по графику
              </template>
              <template v-slot:prepend>
                <v-avatar size="20">
                  <v-icon :icon="['far', 'file-pdf']" />
                </v-avatar>
              </template>

              <v-bottom-sheet activator="parent">
                <v-card>
                  <template v-slot:title>
                    <p>Ассистент генерации план-графиков</p>
                  </template>
                  <template v-slot:subtitle>
                    <p>Отчёт строится не более чем на 3 года</p>
                  </template>
                  <template v-slot:text>
                    <v-sheet class="d-flex align-center">
                      <v-responsive max-width="500" min-width="400" class="mr-4">
                        <v-text-field
                            v-model="filename"
                            density="compact"
                            flat
                            hide-details
                            label="Имя файла"
                            rounded="lg"
                            single-line
                            variant="solo-filled"
                        >
                          <template v-slot:append>
                            .pdf
                          </template>
                        </v-text-field>
                      </v-responsive>
                      <div v-if="filename && filename !== ''" class="d-flex justify-center align-center mr-4">
                        <v-responsive max-width="300" min-width="100">
                          <v-select
                              v-model="period.start"
                              rounded="lg"
                              density="compact"
                              flat
                              hide-details
                              single-line
                              variant="solo-filled"
                              :items="['2022', '2023', '2024', '2025']"
                          />
                        </v-responsive>
                        <v-divider vertical v-if="period.start" />
                        <v-responsive max-width="300" min-width="100">
                          <v-select
                              v-if="period.start"
                              v-model="period.end"
                              rounded="lg"
                              density="compact"
                              flat
                              hide-details
                              single-line
                              variant="solo-filled"
                              :items="Array.from(new Array(3),(val,index)=> parseInt(period.start)+index )"
                          />
                        </v-responsive>
                      </div>
                      <v-divider class="mx-2"/>
                      <v-btn
                          rounded="lg"
                          color="black"
                          flat
                          v-if="!check_start() && !check_end()"
                          v-on:click="create_report()"
                      >СОЗДАТЬ!</v-btn>
                    </v-sheet>
                  </template>
                </v-card>
              </v-bottom-sheet>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>
      <v-btn class="mr-1" v-on:click="toggle_deletion()" :color="deletion ? 'red' : 'white'" variant="flat">
        <v-icon :color="deletion ? 'white' : 'black'" :icon="['fas', 'eraser']" :beat-fade="deletion" />
      </v-btn>
      <template v-if="!current.group_guid">
        <template v-for="group in tools" :key="group">
          <v-btn
              class="mr-1"
              v-if="!group.directions"
              :color="group.color"
              v-on:click="select_group(group.guid)"
          >
            {{ group.name }}
          </v-btn>
          <v-btn
              class="mr-1"
              :color="group.color"
              v-else
          >
            <template v-slot:prepend>
              <v-icon :icon="['fas', 'bars']" />
            </template>
            {{ group.name }}
            <v-menu activator="parent">
              <v-list>
                <v-list-item v-for="direction in group.directions" :key="direction" :color="direction.color" v-on:click="select_direction(group.guid, direction.guid)">
                  <template v-slot:title>
                    {{ direction.name }}
                  </template>
                  <template v-slot:append>
                    <v-avatar size="20" :color="direction.color" />
                  </template>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </template>
      </template>
      <v-btn
          v-on:click="clear_tools()"
          v-if="current.group_guid"
          class="mr-2 font-weight-bold"
      >
        <template v-slot:prepend>
          <v-icon :icon="['fas', 'xmark']" />
        </template>

        <span v-html="get_current_huminized()" />
      </v-btn>

      <v-spacer></v-spacer>

      <v-sheet class="d-flex justify-space-between align-center">
        <v-btn :disabled="is_loading" class="mr-1" v-on:click="set_period('prev')">
          <span class="font-weight-bold">ПРЕД.</span>
          {{ get_period_huminized(period_prev) }}
          <v-tooltip activator="parent" class="d-flex justify-center align-center" location="bottom">
            <v-chip variant="outlined" rounded="sm" size="small">Ctrl</v-chip>
            <v-chip variant="text" rounded="sm" size="small"><v-icon :icon="['fas', 'plus']" /></v-chip>
            <v-chip variant="outlined" rounded="sm" size="small"><v-icon :icon="['fas', 'arrow-left']" /></v-chip>
          </v-tooltip>
        </v-btn>
        <div class="mr-1 d-flex align-center flex-column">
          <v-btn density="compact" size="small" class="mb-1" v-on:click="add_period_size()" :disabled="!(period_size < 3)">
            <v-icon :icon="['fas', 'magnifying-glass-plus']" />
          </v-btn>
          <v-btn density="compact" size="small" v-on:click="enc_period_size()" :disabled="!(period_size > 1)">
            <v-icon :icon="['fas', 'magnifying-glass-minus']" />
          </v-btn>
        </div>
        <v-btn :disabled="is_loading" v-on:click="set_period('next')"><span class="font-weight-bold">СЛЕД.</span>
          {{ get_period_huminized(period_next) }}
          <v-tooltip activator="parent" class="d-flex justify-center align-center" location="bottom">
            <v-chip variant="outlined" rounded="sm" size="small">Ctrl</v-chip>
            <v-chip variant="text" rounded="sm" size="small"><v-icon :icon="['fas', 'plus']" /></v-chip>
            <v-chip variant="outlined" rounded="sm" size="small"><v-icon :icon="['fas', 'arrow-right']" /></v-chip>
          </v-tooltip>
        </v-btn>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { Current, Deletion } from "@/store/planner/ToolsStore";
import { CurrentPeriod, PeriodSize } from "@/store/planner/CurrentPeriodStore";
import moment from "moment";
import  {Allerts } from "@/store/global/Allerts";
import { SP_End, SP_Start, SP_User } from "@/store/planner/SelectedPeriodStore";
import { jsPDF } from "jspdf";
import { AllPeriods } from "@/store/planner/PeriodsStore";
import {IsLoading} from "@/store/directors_planner.store";

export default {
  name: "ScheduleToolbelt",
  props: ['tools'],
  beforeMount() {
    this.filename = `План график ${this.period.start}`
    document.addEventListener('keydown', ev => {
      if (ev.ctrlKey) {
        if (ev.keyCode === 37) {
          if (!this.is_loading) {
            this.set_period('prev')
          }
        }
        if (ev.keyCode === 39) {
          if (!this.is_loading) {
            this.set_period('next')
          }
        }
      }
    })

  },
  data() {
    return {
      special_periods: null,
      filename: null,
      period: {
        start: parseInt(moment().format('YYYY')),
        end: null
      },
      pdf: new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [210, 297]
      }),
      rows: 1
    }
  },
  methods: {
    check_start: function () {
      let s = this.period.start
      if (parseInt(s)) {
        if (parseInt(s) >= 2023) {
          return false
        }
      }
      return true
    },
    check_end: function () {
      let s = this.period.end
      if (parseInt(s)) {
        if (parseInt(s) >= this.period.start && parseInt(s) <= parseInt(this.period.start)+2) {
          return false
        }
      }
      return true
    },

    create_report: async function () {
      await this.get_planner_periods()
    },
    get_planner_periods: async function () {
      let body = JSON.stringify({
        date: this.start_of_year.format('YYYY-MM-DD[T]00:00:00'),
        size: this.range
      })
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetPlannerData`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: body
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            let data = JSON.parse(result)
            for (let district of data) {
              district.users = district.users.sort(function (x, y) {
                if (x.user_name < y.user_name) return -1;
                if (x.user_name > y.user_name) return 1;
                return 0;
              })
            }
            for (let district of data) {
              for (let user of district.users) {
                if (user.periods) {
                  user.periods = user.periods.sort((a, b) => {
                    if (new Date(a.date_start) < new Date(b.date_start)) return -1;
                    if (new Date(a.date_start) > new Date(b.date_start)) return 1;
                    if (new Date(a.date_end) < new Date(b.date_end)) return -1;
                    if (new Date(a.date_end) > new Date(b.date_end)) return 1;
                    return 0
                  })
                }
              }
            }
            await this.save_to_file(data)
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    },
    save_to_file: async function (data) {
      this.pdf.setFontSize(14)
      this.pdf.setFont('DinCyBd')
      this.pdf.setTextColor('#000')
      this.add_text('План-график сотрудников')
      this.add_text('')
      this.add_text('')

      for (let district of data) {
        this.pdf.setFont('DinCyBd')
        this.pdf.setTextColor('#000')
        this.add_text(district.district_name)

        for (let person of district.users) {
          this.pdf.setFont('DinCyRg')
          this.pdf.setTextColor('#000')
          this.add_text(person.user_name)

          if (person.periods) {
            for (let period of person.periods) {
              if (period) {
                let color = '#000'
                if (period.period_guid) {
                  let tmp = this.tools.find(el => el.guid === period.period_guid)
                  color = tmp.color
                }
                if (period.direction_guid) {
                  let group = this.tools.find(el => el.guid === period.period_guid)
                  let tmp = group.directions.find(el => el.guid === period.direction_guid)
                  color = tmp.color
                }
                this.pdf.setFont('DinCyRg')
                this.pdf.setTextColor(moment(period.date_end) < moment() ? '#dddddd' : color)
                if (this.rows >= 48) {
                  this.rows = 1
                  this.pdf.addPage()
                }
                this.pdf.text(`${period.period_name} ${period.direction_name ? period.direction_name : ''}`, 10, this.rows*6, 'left')
                this.pdf.setTextColor(moment(period.date_end) < moment() ? '#dddddd' : '#000000')
                this.pdf.text(`${moment(period.date_start).format('DD.MM.YYYY')} - ${moment(period.date_end).format('DD.MM.YYYY')}`, 200, this.rows*6, 'right')
                this.rows ++
              }
            }
          } else {
            this.pdf.setFont('DinCyRg')
            this.pdf.setTextColor('#959595')
            this.add_text('Данных нет!')
          }
        }
      }

      await this.pdf.save(`${this.filename}.pdf`)
    },
    add_text: function (text) {
      if (this.rows >= 48) {
        this.rows = 1
        this.pdf.addPage()
      }
      this.pdf.text(`${text}`, 10, this.rows*6, 'left')
      this.rows ++
    },

    get_period_huminized: function (period) {
      let start = period.format('YYYY MMM')
      let end = moment(period.format()).add(this.period_size-1, 'months' ).format('YYYY MMM')
      if (start === end) {
        return `${start}`
      } else {
        return `${start} - ${end}`
      }
    },
    add_period_size: function () {
      if (this.period_size < 3) {
        this.period_size++
      } else {
        Allerts().allert('ОШИБКА', 'Период не может быть больше 3!', 'triangle-exclamation')
      }
    },
    enc_period_size: function () {
      if (this.period_size > 1) {
        this.period_size--
      } else {
        Allerts().allert('ОШИБКА', 'Период не может быть меньше 1!', 'triangle-exclamation')
      }
    },
    get_current_huminized: function () {
      let current = ''

      if (this.current.group_guid) {
        let tmp = this.tools.find(el => el.guid === this.current.group_guid)
        current += `<span style="color: ${tmp.color}">${tmp.name}</span>`
      }

      if (this.current.direction_guid) {
        let group = this.tools.find(el => el.guid === this.current.group_guid)
        let tmp = group.directions.find(el => el.guid === this.current.direction_guid)
        current += ` <span style="color: ${tmp.color}">${tmp.name}</span>`
      }

      return current
    },
    set_period: function (type) {
      switch (type) {
        case 'prev':
          this.period_current = this.period_prev
          break;
        case 'next':
          this.period_current = this.period_next
          break;
      }
    },
    clear_tools: function () {
      this.current = {
        group_guid: null,
        direction_guid: null
      }
      this.deletion = false
      this.period_start = null
      this.period_end = null
      this.period_user = null
    },
    toggle_deletion: function () {
      this.deletion = !this.deletion
    },
    select_group: function (group) {
      this.current = {
        group_guid: group,
        direction_guid: null
      }
    },
    select_direction: function (group, direction) {
      this.current = {
        group_guid: group,
        direction_guid: direction
      }
    }
  },
  watch: {
    start() {
      this.period.end = null
    }
  },
  computed: {
    start() {
      return this.period.start
    },
    start_of_year() {
      return moment(`${this.period.start}-01-01`).startOf('year')
    },
    range() {
      let end = parseInt(this.period.end)
      let start = parseInt(this.period.start)
      return ((end - start) + 1) * 12
    },
    periods: {
      get() {
        return AllPeriods().get()
      },
      set(value) {
        AllPeriods().set(value)
      }
    },
    period_next() {
      return moment(this.period_current.format()).add(1, 'months' )
    },
    period_prev() {
      return moment(this.period_current.format()).subtract(1, 'months')
    },
    period_start: {
      get() {
        return SP_Start().get()
      },
      set(value) {
        SP_Start().set(value)
      }
    },
    period_end: {
      get() {
        return SP_End().get()
      },
      set(value) {
        SP_End().set(value)
      }
    },
    period_user: {
      get() {
        return SP_User().get()
      },
      set(value) {
        SP_User().set(value)
      }
    },
    current: {
      get() {
        return Current().get()
      },
      set(value) {
        Current().set(value)
      }
    },
    deletion: {
      get() {
        return Deletion().get()
      },
      set(value) {
        Deletion().set(value)
      }
    },
    is_loading: {
      get() {
        return IsLoading().get()
      },
      set(value) {
        IsLoading().set(value)
      }
    },
    period_current: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    },
    period_size: {
      get() {
        return PeriodSize().get()
      },
      set(value) {
        PeriodSize().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>
